import React, { useState, useEffect } from "react";
import iconPlus from '../../Images/IconPlus.svg';
import iconMinus from '../../Images/IconMinus.svg';

const MessageA3intent = (props) => {
    const { item, setErrors ,showMaximumChat } = props;
    let data = JSON.parse(item?.text);
    const messageType = data?.messageType;
    const [selectedEntities, setSelectedEntities] = useState({});
    const [selectedButtonIndex, setSelectedButtonIndex] = useState(null);
    const [selectedEntity, setSelectedEntity] = useState([]);
    const [openDetailsIndex, setOpenDetailsIndex] = useState(null); // Track expanded detail

    const buildFormattedDisplayValue = (intent, subIntent, entities) => {
        return [
            intent.replace(/_/g, " "),
            subIntent && subIntent.replace(/_/g, " "),
            entities?.join(", ")
        ].filter(Boolean).join(" : ");
    };
    const buildFormattedValue = (intent, subIntent, entities) => {
        return [
            intent,
            subIntent && subIntent.replace(/_/g, " "),
            entities?.join(", ")
        ].filter(Boolean).join(" : ");
    };


    useEffect(() => {
        if (data?.choices?.length === 1) {
            const choice = data.choices[0];
            const isPakage = messageType === "package" || messageType === "billing"  ;
            const allEntities = choice?.entities || {};

            const intent = choice?.intent || "";
            const subIntent = choice?.sub_intent || "";
            const entityList = Object.values(allEntities).flat();
            const displayName = buildFormattedDisplayValue(intent, subIntent, entityList);
            const value = buildFormattedValue(intent, subIntent, entityList);

            localStorage.setItem("inputValue1", JSON.stringify({ key1: displayName }));
            setErrors?.((prevErrors) => ({
                ...prevErrors,
                [props?.index]: { key1: value, displayName },
            }));

            setSelectedEntities(allEntities);
            setSelectedButtonIndex(0);

            if (Object.keys(allEntities).length === 0) {
                localStorage.setItem("inputValue", JSON.stringify({ key1: '' }));
            } else if (isPakage) {
                setSelectedEntity(entityList);
                localStorage.setItem("inputValue", JSON.stringify({ key1: displayName }));
            }
        }
    }, [data?.choices?.length, messageType]);

    useEffect(() => {
        const entityTypes = Object.keys(selectedEntities);
        if (entityTypes.length === 1) {
            const entityType = entityTypes[0];
            const entities = selectedEntities[entityType];

            if (entities?.length === 1 && (messageType !== "package" ||  messageType !== "billing")) {
                const singleEntity = entities[0];
                setSelectedEntity(singleEntity);

                const selectedChoice = data.choices[selectedButtonIndex];
                const displayName = buildFormattedDisplayValue(
                    selectedChoice?.intent || "",
                    selectedChoice?.sub_intent || "",
                    [singleEntity]
                );

                localStorage.setItem("inputValue", JSON.stringify({ key1: displayName }));
            }
        }
    }, [selectedEntities, messageType]);

    return (
        <div>
            <div style={{ padding: "8px" }} className="header-prob">
                {data?.response?.intent}
            </div>

            <div
                className="a1-wrap"
                style={{
                    width: "fit-content",
                    margin: '6px',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                }}
            >
                {data?.choices.map((choice, index) => (
                    <div key={index}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button
                                className={selectedButtonIndex === index ? 'chat-label-select action-tab' : 'chat-label action-tab'}
                                onClick={() => {
                                    const intent = choice?.intent || "";
                                    const subIntent = choice?.sub_intent || "";
                                    const allEntities = choice?.entities || {};

                                    setSelectedEntities(allEntities);
                                    setSelectedButtonIndex(index);

                                    const entityList = (messageType === "package" || messageType === "billing" )
                                        ? Object.values(allEntities).flat()
                                        : [];

                                    setSelectedEntity(entityList);

                                    const displayName = buildFormattedDisplayValue(intent, subIntent, entityList);
                                    const value = buildFormattedValue(intent, subIntent, entityList);

                                    localStorage.setItem("inputValue1", JSON.stringify({ key1: displayName }));
                                    localStorage.setItem("inputValue", JSON.stringify({ key1: displayName }));

                                    setErrors?.((prevErrors) => ({
                                        ...prevErrors,
                                        [props?.index]: { key1: value, displayName },
                                    }));

                                    if (Object.keys(allEntities).length === 0) {
                                        setSelectedEntity([]);
                                        localStorage.setItem("inputValue", JSON.stringify({ key1: '' }));
                                    } else if (messageType !== "package" || messageType !== "billing"  ) {
                                        setSelectedEntity([]);
                                    }
                                }}
                            >
                                {choice?.intent.replace(/_/g, " ")}
                            </button>

                            {(choice?.sub_intent || Object.keys(choice?.entities || {}).length > 0) && (
                                <img
                                    src={openDetailsIndex === index ? iconMinus : iconPlus}
                                    alt="toggle"
                                    onClick={() => setOpenDetailsIndex(openDetailsIndex === index ? null : index)}
                                    style={{
                                        cursor: 'pointer',
                                        marginLeft: '8px',
                                        position: !showMaximumChat && 'absolute',
                                        right: !showMaximumChat && '30px'
                                    }}
                                />
                            )}
                        </div>

                        {openDetailsIndex === index && (
                            <>
                                {choice?.sub_intent && (
                                    <div
                                        style={{
                                            background: "#a9f4a9",
                                            padding: "10px",
                                            marginTop: "10px",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            border: '1px solid #dedddd',
                                            borderRadius: '8px'
                                        }}
                                    >
                                        <div style={{ fontWeight: "bold", color: "#333" }}>Sub Intent:</div>
                                        <div style={{ marginTop: "4px" }}>{choice?.sub_intent.replace(/_/g, " ")}</div>
                                    </div>
                                )}

                                {/* {Object.entries(choice?.entities || {}).map(([entityType, values]) => ( */}
                                {Object.entries(choice?.entities || {}).filter(([entityType]) => entityType !== "none").map(([entityType, values]) => (
                                    <div style={{ marginTop: '10px' }} key={entityType}>
                                        <div style={{ marginLeft: "11px", fontWeight: "100" }} className="header-prob">
                                            {entityType}
                                        </div>
                                        <ul style={{ margin: 'auto' }}>
                                            {values.map((entity, idx) => (
                                                <li key={idx}>
                                                    <button
                                                        className={selectedEntity.includes(entity) ? 'option-button clicked' : 'option-button'}
                                                        style={{ borderRadius: '10px', margin: '5px', width: 'auto' }}
                                                        onClick={() => {
                                                            // if (messageType === "package" ||  messageType === "billing") return;

                                                            setSelectedEntity((prev) => {
                                                                if (!Array.isArray(prev)) prev = [];

                                                                const isAlreadySelected = prev.includes(entity);
                                                                const updated = isAlreadySelected
                                                                    ? prev.filter((item) => item !== entity)
                                                                    : [...prev, entity];

                                                                const selectedChoice = data.choices[selectedButtonIndex];
                                                                const displayName = buildFormattedDisplayValue(
                                                                    selectedChoice?.intent || "",
                                                                    selectedChoice?.sub_intent || "",
                                                                    updated
                                                                );
                                                                const value = buildFormattedValue(
                                                                    selectedChoice?.intent || "",
                                                                    selectedChoice?.sub_intent || "",
                                                                    updated
                                                                );

                                                                localStorage.setItem("inputValue", JSON.stringify({ key1: displayName }));

                                                                setErrors?.((prevErrors) => ({
                                                                    ...prevErrors,
                                                                    [props?.index]: { key1: value, displayName },
                                                                }));

                                                                return updated;
                                                            });
                                                        }}
                                                        // disabled={messageType === "package" || messageType === "billing" }
                                                    >
                                                        {entity}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MessageA3intent;
